module.exports = __webpack_public_path__ + "static/img_2127-cf6b5137c86f913241e996c168fd4839.webp";